import { ClickEvent } from "@mcleod/components";
import { Navigation } from "@mcleod/core";
import { AutogenLayoutCarrierRateQuickInfo } from "./autogen/AutogenLayoutCarrierRateQuickInfo";

export class CarrierRateQuickInfo extends AutogenLayoutCarrierRateQuickInfo {

    /** This is an event handler for the onClick event of buttonCarrierRate.  */
    buttonCarrierRateOnClick(event: ClickEvent) {
        Navigation.navigateTo(`lme/dispatch/rates/CarrierRate?mode=update&key=${this.mainDataSource.activeRow.get("id")}`, {
            newTab: true
        });
    }
}
